/*
 * VAT switcher
 * - Flips <html> between .vat-inc and .vat-ex (CSS does the rest; every price is
 *   already rendered both ways by Liquid, so section re-renders keep working).
 * - Remembers the choice for a year in the `vat_mode` cookie (`vat_mode_b2b` for
 *   logged-in B2B customers, whose default is ex VAT).
 * - Copies the choice to the cart attribute `_vat_mode` so checkout (and the order
 *   in admin) knows which way the customer was viewing prices.
 */
(function () {
  if (window.VatSwitcher) return;

  var html = document.documentElement;
  // B2B customers get their own cookie (set by vat-head) so they default to ex VAT.
  var COOKIE = html.getAttribute('data-vat-cookie') || 'vat_mode';
  var ATTR = '_vat_mode';

  function locked() {
    return html.hasAttribute('data-vat-locked');
  }

  function getMode() {
    return html.classList.contains('vat-ex') ? 'ex' : 'inc';
  }

  function hasCart() {
    return /(?:^|;\s*)cart=/.test(document.cookie);
  }

  function syncButtons(mode) {
    document.querySelectorAll('.vat-toggle__btn').forEach(function (btn) {
      btn.setAttribute('aria-pressed', String(btn.dataset.vatMode === mode));
    });
  }

  function announce(mode) {
    var label = mode === 'ex' ? 'Prices now shown excluding VAT' : 'Prices now shown including VAT';
    document.querySelectorAll('[data-vat-status]').forEach(function (el) {
      el.textContent = label;
    });
  }

  function syncCart(mode) {
    if (!hasCart() || html.getAttribute('data-vat-cart') === mode) return Promise.resolve();
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var attributes = {};
    attributes[ATTR] = mode;
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes }),
    })
      .then(function (res) {
        if (res.ok) html.setAttribute('data-vat-cart', mode);
      })
      .catch(function () {
        /* Display still works without the attribute; checkout falls back to inc. */
      });
  }

  function setMode(mode) {
    if (locked() || (mode !== 'inc' && mode !== 'ex')) return;
    var previous = getMode();
    html.classList.remove('vat-inc', 'vat-ex');
    html.classList.add('vat-' + mode);
    document.cookie = COOKIE + '=' + mode + '; path=/; max-age=31536000; SameSite=Lax';
    syncButtons(mode);
    if (previous !== mode) {
      announce(mode);
      document.dispatchEvent(new CustomEvent('vat:change', { detail: { mode: mode } }));
    }
    syncCart(mode);
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.vat-toggle__btn');
    if (!btn) return;
    event.preventDefault();
    setMode(btn.dataset.vatMode);
  });

  function init() {
    syncButtons(getMode());
    if (locked()) return;
    syncCart(getMode());
    // When the first item goes in the basket a new cart is created, so carry the
    // customer's current choice onto it (Dawn's pub/sub, if present).
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        syncCart(getMode());
      });
      // Product sections can be re-rendered on variant change; keep button states right.
      if (PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, function () {
          setTimeout(function () {
            syncButtons(getMode());
          }, 0);
        });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.VatSwitcher = { getMode: getMode, setMode: setMode };
})();